<div class="container-fluid">
    <fap-activity-groups-layout
        [activityGroups]="activityGroups$ | async"
        [activities]="activities$ | async"
        (deleteActivityGroup)="deleteActivityGroup($event)">
    </fap-activity-groups-layout>
</div>
